module.exports = __webpack_public_path__ + "static/media/APOTHEO_LABO_PURESSENTIEL.263a4fe7.jpeg";